import React from 'react';
import styled from 'styled-components';
import { showDialog } from '../components/dialog';
import Tooltip from '../components/Tooltip';
import l10n from '../shared/strings';
import Logger from '../services/Logger';

const StyledContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 20px;
`;
const StyledItem = styled.div`
  box-sizing: border-box;
  width: 200px;
  min-height: 200px;
  padding: 45px 10px 20px;
  text-align: center;
  background-color: var(--grey-200-color);
  border-radius: 8px;
  transition: all .2s;
  color: var(--text-color);

  ${({ disabled }) => disabled && `
    pointer-events: none;
    opacity: 0.4;
  `}

  .PicsioIcon {
    font-size: 55px;
    margin-bottom: 10px;
    transition: all .2s;
  }

  &:hover {
    cursor: pointer;
    background: var(--grey-300-color);
    color: var(--title-color);

    .PicsioIcon {
      color: var(--accent-primary-color);
    }
  }
`;
const StyledText = styled.div`
  margin: 0 0 5px;
`;
const StyledSubText = styled.div`
  font-size: .88em;
  color: var(--grey-500-color);
`;

const Item = ({
  icon, text, subtext, onClick, disabled, testId,
}) => (
  <StyledItem onClick={onClick} disabled={disabled} data-testid={testId}>
    {icon}
    <StyledText>{text}</StyledText>
    <StyledSubText>{subtext}</StyledSubText>
  </StyledItem>
);

const { TITLE, ITEMS } = l10n.DIALOGS.SELECT_SHARING_METHOD;

export default async function showSelectSharingMethodDialog(eventProps = {}, isSasDisabled = false) {
  Logger.log('UI', 'SharingMethodModalShown', eventProps);

  return new Promise((resolve) => {
    const close = showDialog({
      title: TITLE,
      children: (
        <StyledContainer>
          {ITEMS.map(({
            key, icon, text, subtext, eventName, disabledTooltip, testId,
          }) => (
            <Tooltip key={key} placement="top" content={isSasDisabled && key === 'sas' ? disabledTooltip : null}>
              <div> {/** Tooltip fails without a wrapping element */}
                <Item
                  icon={icon}
                  text={text}
                  subtext={subtext}
                  disabled={isSasDisabled && key === 'sas'}
                  testId={testId}
                  onClick={() => {
                    resolve(key);
                    Logger.log('User', eventName, eventProps);
                    close();
                  }}
                />
              </div>
            </Tooltip>
          ))}
        </StyledContainer>
      ),
      textBtnOk: null,
      style: { width: 'auto' },
      onCancel: () => {
        Logger.log('User', 'SharingMethodModalClosed');
        resolve(null);
      },
    });
  });
}
